import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

import {ContentModel} from '@drl/shared/components/cms-list/models';

export class GetGalleryCommand extends GetListAPICommand<ContentModel> {
  constructor(apiService: ApiService, adapter: IAdapter<ContentModel>) {
    super(apiService, adapter, `${environment.cmsApiUrl}/gallery`);
  }
}
